var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-youtube';
                    var viewUrl = 'sprite.svg#view-logo-youtube';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-youtube#logo-youtube';
                            viewUrl = 'sprite.svg?logo-youtube#view-logo-youtube';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 461.001 461.001',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };